let debugMode = 0,
    version = 3.2;

(function (global, factory) {

    if (!window) throw "Unable to start this plugin without window object";
    else if (typeof jQuery == "undefined") throw "Parsis JS unable to start without jQuery plugin";
    else factory(global);

}(typeof window !== "undefined" ? window : this, function (window, noGlobal) {

    jQuery.extend(jQuery.expr.pseudos, {
        attrStartsWith: function (el, _, b) {
            for (let i = 0, atts = el.attributes, n = atts.length; i < n; i++) {
                if(atts[i].nodeName.toLowerCase().indexOf(b[3].toLowerCase()) === 0) {
                    return true;
                }
            }

            return false;
        }
    });

    let App = function (selector) {
        return new App.fn.init(selector);
    };

    App.fn = App.prototype = {
        init: function (selector) {
            if (!selector) return jQuery();
            else if (selector instanceof jQuery) return selector;
            else if (typeof selector === "string") return jQuery("#" + selector);
            else return jQuery(selector);
        },
        search: function (element) {
            let $wrap = jQuery(this);
            return $wrap.find("[data-element=\"" + element + "\"]");
        },
    };

    App.fn.init.prototype = App.prototype;

    // Add custom app plugin to jQuery
    jQuery.fn.search = App.fn.search;
    jQuery.fn.validate = App.fn.validate;

    if (!noGlobal) {
        window.$$ = window.Parsis = window.General = App;
    }

    console.log('PARSIS JS: Parsis JS is installed, version ' + version);

    return App;
}));
